import { ERROR_CODES } from './ErrorCodes'
import { GenericException } from './GenericException'

export type Method = 'GET' | 'POST' | 'PUT' | 'DELETE'

export class MethodNotAllowedException extends GenericException {
  constructor(method?: Method) {
    super({
      ...ERROR_CODES.METHOD_NOT_ALLOWED,
    })

    if (method) {
      this.developerMessage = `HTTP method ${method} not supported for the requested endpoint`
    }
  }
}
